import moment from "moment";

const ageFormatter = (date: string) => {
   return moment().diff(moment(`${date} 00:00:00`), "years")
}

export default ageFormatter